module.exports = __webpack_public_path__ + "img/Joe.1a1fd069.png";